import {isUSRegion} from "@/region.ts";

export const ZENDESK_TAGS_ARTICLE =
  "https://support.uptime.com/hc/en-us/articles/360001254399-Tags-and-Filtering-Basics";
export const URL_MONITORING_SERVERS = "/monitoring";
export const UPTIME_FEEDBACK_URL = "https://uptime.featurebase.app/?b=66e0a886e42577ee1c6c0a67";
export const UPTIME_STATUSPAGE_URL = isUSRegion()
  ? "https://status.uptime.com/"
  : "https://eu.uptime.com/statuspage/probe-server-status";
